<template>
    <!-- modal-xl -->
    <b-modal id="createOptionModal" title="Create Option Modal" title-class="font-18" hide-footer no-close-on-backdrop>
        <div class="textcenter">
            <!-- <h5 class="mb-3">{{ this.searchForm.company_name }}</h5> -->
            <!-- <p>Regulation: Regulation V.1</p>
            <p>Check: Has Title</p>
            <hr /> -->
            <b-form>
                <b-form-group label="Value:" label-cols-sm="3" label-size="sm" class="align-text-setting mr-5">
                    <b-form-input
                        v-model="$v.optionForm.value.$model"
                        size="sm"
                        :state="validateState('value')"
                        aria-describedby="input-1-live-feedback"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-1-live-feedback" class="text-left ml-2">
                        Required
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-form>
        </div>

        <div class="modal-footer mt-3">
            <b-button @click="createOption" variant="primary" type="button" class="btn btn-primary">
                Save
            </b-button>
            <b-button variant="primary" type="button" class="btn btn-primary" @click="closeModal">
                Close
            </b-button>
        </div>
    </b-modal>
</template>

<script>
//eslint-disable-next-line
import Swal from "sweetalert2";
import { certificateValidationComputed, certificateValidationMethods } from "../../../state/helpers";
//eslint-disable-next-line
import { required, minLength, maxLength, numeric, date } from "vuelidate/lib/validators";

export default {
    data: () => ({
        formSubmit: false,
        //values for the calendar
        optionForm: {
            value: "",
        },
    }),
    validations: {
        optionForm: {
            value: { required, minLength: minLength(2) },
        },
    },
    computed: {
        ...certificateValidationComputed,
    },
    methods: {
        ...certificateValidationMethods,
        validateState(name) {
            if (this.formSubmit) {
                const { $dirty, $error } = this.$v.optionForm[name];
                return $dirty ? !$error : null;
            }
        },

        closeModal() {
            this.$bvModal.hide("createOptionModal");
        },
        createOption() {
            this.formSubmit = true;

            this.$v.optionForm.$touch();
            if (this.$v.optionForm.$anyError) {
                return;
            }
            //eslint-disable-next-line
            console.log(this.checks_by_regulation_version);

            this.saveCreateValidationOption({
                check_id: this.selected_check_details.id,
                value: this.optionForm.value,
            }).then(() => {
                //eslint-disable-next-line
                console.log("created");
                // this.setRegulationVersions();
                // this.setValidationChecksByRegulationVersion({regulation_version_id: });
                this.setCheckOptions({ check_id: this.selected_check_details.id });
                this.closeModal();

                Swal.fire(`Check Created`, "successfully", "");
            });

            //eslint-disable-next-line
            console.log("send the option");
        },
    },
    mounted() {
        //eslint-disable-next-line
        console.log("createOptionModal");
    },
};
</script>

<style lang="scss" scoped>
.align-text-setting {
    text-align: right;
}
@media only screen and (max-width: 990px) {
    .align-text-setting {
        text-align: left;
    }
}
</style>
